/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetUploadIcon16Light } from './NetUploadIcon16Light';
import { NetUploadIcon16Regular } from './NetUploadIcon16Regular';
import { NetUploadIcon16Solid } from './NetUploadIcon16Solid';
import { NetUploadIcon20Light } from './NetUploadIcon20Light';
import { NetUploadIcon20Regular } from './NetUploadIcon20Regular';
import { NetUploadIcon20Solid } from './NetUploadIcon20Solid';
import { NetUploadIcon24Regular } from './NetUploadIcon24Regular';
import { NetUploadIcon24Solid } from './NetUploadIcon24Solid';
import { NetUploadIcon32Regular } from './NetUploadIcon32Regular';
import { NetUploadIcon64Regular } from './NetUploadIcon64Regular';
var sizes = {
    16: {
        light: NetUploadIcon16Light,
        regular: NetUploadIcon16Regular,
        solid: NetUploadIcon16Solid,
    },
    20: {
        light: NetUploadIcon20Light,
        regular: NetUploadIcon20Regular,
        solid: NetUploadIcon20Solid,
    },
    24: {
        regular: NetUploadIcon24Regular,
        solid: NetUploadIcon24Solid,
    },
    32: {
        regular: NetUploadIcon32Regular,
    },
    64: {
        regular: NetUploadIcon64Regular,
    },
};
export var NetUploadIcon = forwardRef('NetUploadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
